import { Pipe, PipeTransform } from '@angular/core';

// Rich text pasted into admin (e.g. from Word/Outlook) can join every word with non-breaking spaces,
// which turns whole paragraphs into a single unbreakable word that overflows its container.
const NBSP_PATTERN = /&nbsp;|&#160;|&#x0*a0;| /gi;

@Pipe({
    standalone: true,
    name: 'nbspToSpace',
})
export class NbspToSpacePipe implements PipeTransform {
    transform(value: string | null | undefined): string | null | undefined {
        return value ? value.replace(NBSP_PATTERN, ' ') : value;
    }
}
